import { lighten, makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import React from "react";
import { COLORS } from "../../constants/Colors";

const EnhancedTableToolbar = (props) => {
  const useToolbarStyles = makeStyles((theme) => ({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
    },

    highlight:
      theme.palette.type === "light"
        ? {
            color: COLORS.iStaffGreen,
            backgroundColor: lighten(COLORS.WHITE, 1),
          }
        : {
            color: COLORS.iStaffGreenDarker,
            backgroundColor: lighten(COLORS.iStaffGreenDarker, 1),
          },
    title: {
      flex: "1 1 100%",
    },
  }));

  const classes = useToolbarStyles();
  const { numSelected, title } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <Typography
        className={classes.title}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        {title}
      </Typography>
    </Toolbar>
  );
};

export default EnhancedTableToolbar;
